/*
 * When adding a flag, add this url to the flag for easy navigation.
 * https://app.launchdarkly.com/default/production/features/YOUR_FLAG_HERE/targeting
 */

export const featureFlags = {
  billing: {
    // https://app.launchdarkly.com/default/production/features/behaviour.billing.invoicing.payments/targeting
    payments: "behaviour.billing.invoicing.payments",
    // https://app.launchdarkly.com/default/production/features/behaviour.billing.invoicing.blockRefunds/targeting
    blockRefunds: "behaviour.billing.invoicing.blockRefunds",
    // https://app.launchdarkly.com/default/production/features/rollout.billing.exemption/targeting
    exemption: "rollout.billing.exemption",
    // https://app.launchdarkly.com/default/production/features/behaviour.billing.invoicing.blockWaive/targeting
    blockWaive: "behaviour.billing.invoicing.blockWaive",
    // https://app.launchdarkly.com/default/production/features/price-list.rxdb/targeting
    priceListRxdb: "price-list.rxdb",
    // https://app.launchdarkly.com/default/production/features/billing.rxdb/targeting
    billingRxdb: "billing.rxdb",
    // https://app.launchdarkly.com/default/production/features/price-list.bulk-upload/targeting
    priceListBulkUpload: "price-list.bulk-upload",
    // https://app.launchdarkly.com/default/production/features/rxdb-billing/targeting
    rxdbBilling: "rxdb-billing",
    // https://app.launchdarkly.com/default/production/features/price-list.bulk-percentage-adjust/targeting
    priceListBulkPercentageAdjust: "price-list.bulk-percentage-adjust",
  },
  pocus: {
    // https://app.launchdarkly.com/projects/default/flags/pocus.createSonographer/targeting
    createSonographer: "pocus.createSonographer",
    // https://app.launchdarkly.com/projects/default/flags/pocus.imagingStudySync/targeting
    imagingStudySync: "pocus.imagingStudySync",
    // https://app.launchdarkly.com/projects/default/flags/pocus.referralsSync/targeting
    referralsSync: "pocus.referralsSync",
    // https://app.launchdarkly.com/projects/default/flags/pocus.patientHistory/targeting
    patientHistory: "pocus.patientHistory",
    // https://app.launchdarkly.com/projects/default/flags/pocus.ge-demo/targeting
    geDemo: "pocus.ge-demo",
  },
  epocus: {
    // https://app.launchdarkly.com/projects/default/flags/epocus.referrals/targeting
    referrals: "epocus.referrals",
    // https://app.launchdarkly.com/projects/default/flags/epocus.assign-to-reviewer/targeting
    assignToReviewer: "epocus.assign-to-reviewer",
    // https://app.launchdarkly.com/projects/default/flags/epocus.billing-codes/targeting
    billingCodes: "epocus.billing-codes",
    // https://app.launchdarkly.com/projects/default/flags/epocus.serial-restricted-triage/targeting
    serialRestrictedTriage: "epocus.serial-restricted-triage",
    // https://app.launchdarkly.com/projects/default/flags/hackathon-sept-26/targeting
    hackathonSept26: "hackathon-sept-26",
    // https://app.launchdarkly.com/projects/default/flags/hackathon-voice-control/targeting
    hackathonVoiceControl: "hackathon-voice-control",
    // https://app.launchdarkly.com/projects/default/flags/epocus.onboarding-agent-url/targeting
    onboardingAgentUrl: "epocus.onboarding-agent-url",
  },
  patient: {
    history: {
      // https://app.launchdarkly.com/default/production/features/rollout.patient.history.thermal-print-medication-instructions/targeting
      /**
       * @deprecated: Replace the button with one that is always there. If a
       * printer is not connected when clicked, it shows a warning toast that a
       * printer can't be found.
       */
      thermalPrintMedicationInstructions:
        "rollout.patient.history.thermal-print-medication-instructions",
      // https://app.launchdarkly.com/default/production/features/experiment.patient-history.print-per-consultation/targeting
    },
    // https://app.launchdarkly.com/default/production/features/rollout.patient-search.useRxdbSearch/targeting
    useRxdbSearch: "rollout.patient-search.useRxdbSearch",
  },
  inventory: {
    // https://app.launchdarkly.com/default/production/features/behaviour.stock.v3.clinical-product-edit-permission/targeting
    permClinicalProductPermissions:
      "behaviour.stock.v3.clinical-product-edit-permission",
    // https://app.launchdarkly.com/default/production/features/inventory.bulk-receive/targeting
    bulkReceive: "inventory.bulk-receive",
    // https://app.launchdarkly.com/default/production/features/inventory.bulk-stocktake/targeting
    bulkStocktake: "inventory.bulk-stocktake",
  },
  clinical: {
    // https://app.launchdarkly.com/projects/default/flags/clinical.non-pharma/targeting
    nonPharma: "clinical.non-pharma",
  },
  // https://app.launchdarkly.com/default/production/features/rollout.patient-pay/targeting
  patientPay: "rollout.patient-pay",
  // https://app.launchdarkly.com/default/production/features/rollout.apqEnabled/targeting
  /** @deprecated: True for all, delete. */
  apqEnabled: "rollout.apqEnabled",
  // https://app.launchdarkly.com/default/production/features/rollout.opd-redesign.part-2/targeting
  opdRedesignPart2: "rollout.opd-redesign.part-2",
  // https://app.launchdarkly.com/default/production/features/rollout.opd-redesign.part-3/targeting
  rxdbDataExpiry: "rollout.rxdb.data-expiry",
  // https://app.launchdarkly.com/projects/default/flags/rollout.clear-rx-increment-state/targeting
  clearRxDbIncrementState: "rollout.clear-rx-increment-state",
  // https://app.launchdarkly.com/projects/default/flags/demo.patient-file-upload/targeting
  patientFileUpload: "demo.patient-file-upload",
  // https://app.launchdarkly.com/projects/default/flags/demo.prescription-delete/targeting
  prescriptionDelete: "demo.prescription-delete",
  // https://app.launchdarkly.com/projects/default/flags/demo.immunisation-schedule/targeting
  immunisationSchedule: "demo.immunisation-schedule",
  // https://app.launchdarkly.com/projects/default/flags/demo.fake-heme-health-integration/targeting
  fakeHemeHealthIntegration: "demo.fake-heme-health-integration",
  // https://app.launchdarkly.com/projects/default/flags/demo.capture-patient-email/targeting
  capturePatientEmail: "demo.capture-patient-email",
  // https://app.launchdarkly.com/projects/default/flags/demo.user-national-id-number/targeting
  captureUserNiN: "demo.user-national-id-number",
  // https://app.launchdarkly.com/projects/default/flags/demo.diabetes-management-view/targeting
  diabetesHistoryView: "demo.diabetes-management-view",
  immunisations: {
    // https://app.launchdarkly.com/projects/default/flags/immunisations.add-vaccine-flow/targeting
    addVaccineFlow: "immunisations.add-vaccine-flow",
    // https://app.launchdarkly.com/projects/default/flags/immunisations.vaccination-schedule/targeting
    schedule: "immunisations.vaccination-schedule",
    // https://app.launchdarkly.com/projects/default/flags/immunisations.nudges/targeting
    nudges: "immunisations.nudges",
    // https://app.launchdarkly.com/projects/default/flags/immunisations.registration-reformat/targeting
    childRegistration: "immunisations.registration-reformat",
    // https://app.launchdarkly.com/projects/default/flags/immunisations.registration-reformat/targeting
    // TODO: remove one of these 2 in favour of a single flag
    registrationReformat: "immunisations.registration-reformat",
    // https://app.launchdarkly.com/projects/default/flags/immunisations.register/targeting
    register: "immunisations.register",
  },
  anc: {
    // https://app.launchdarkly.com/projects/default/flags/anc.elephant-2.00-additions/targeting
    elephant200Additions: "anc.elephant-2.00-additions",
  },
  // https://app.launchdarkly.com/projects/default/flags/innoweek.2025/targeting
  innoweek2025: "innoweek.2025",
  notifications: {
    // https://app.launchdarkly.com/projects/default/flags/notifications.center/targeting
    center: "notifications.center",
  },
};
